import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { Decrypt } from "../../../routes/cryptography";
import FileDownload from "js-file-download";
import { Buffer } from "buffer"

//const feedback = "Ты сделал это!";

class DecryptView extends Component {
  constructor() {
    super();
    this.state = {
      dataDecrypt: {
        data: "",
        alg: "belt-ctr256",
        dataPrivKey: "",
      },
      dataFileName: "файл",
      dataFileIsOpen: false,

      privkeyFileName: "файл",
      privkeyFileIsOpen: false,

      isValidFileSize: true,
      isValid32KeyFileSize: true,

      tokenFileName: "файл",
      tokenFileIsOpen: false,
      errors: {},
    };
    ///////VerifySign Func////

    this.handleSelectChange = this.handleSelectChange.bind(this);

    this.handleFileForDecryptChange = this.handleFileForDecryptChange.bind(
      this
    );
    this.handleDecryptSubmit = this.handleDecryptSubmit.bind(this);
    this.handlePrivKeyChange = this.handlePrivKeyChange.bind(this);
    //this.handleTokenChange = this.handleTokenChange.bind(this);
    //this.handleInputChangePass = this.handleInputChangePass.bind(this);
  }

  componentDidMount() { }
  handleSelectChange(e) {
    try {
      //console.log(e.target.value);
      this.setState({
        dataDecrypt: {
          ...this.state.dataDecrypt,
          alg: e.target.value,
        },
      });
    } catch (error) {
      //console.log(error);
    }
  }
  // handleInputChangePass(e) {
  //   console.log(e.target.value);
  //   try {
  //     this.setState({
  //       dataDecrypt: {
  //         ...this.state.dataDecrypt,
  //         password: e.target.value,
  //       },
  //     });

  //     //console.log(e.target.value);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }
  handleFileForDecryptChange() {
    try {
      const file = document.getElementById("dataForDecrypt").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {
        this.setState({
          dataFileName: file.name,
          dataFileIsOpen: true,
          isValidFileSize: true
        });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString();

          this.setState({
            dataDecrypt: { ...this.state.dataDecrypt, data: data },
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({
          dataFileName: "файл",
          dataFileIsOpen: false,
          isValidFileSize: false

        });
      }
    } catch (error) {
      //console.log(error);
    }
  }
  handlePrivKeyChange() {
    try {
      const file = document.getElementById("filePrivKey").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {

        this.setState({ privkeyFileName: file.name, privkeyFileIsOpen: true, isValid32KeyFileSize: true });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString("base64");

          this.setState({
            dataDecrypt: { ...this.state.dataDecrypt, dataPrivKey: data },
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({ privkeyFileName: "файл", privkeyFileIsOpen: false, isValid32KeyFileSize: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  // handleTokenChange() {
  //   try {
  //     const file = document.getElementById("fileToken").files[0];
  //     console.log(file);

  //     if (file !== undefined) {
  //       this.setState({ tokenFileName: file.name, tokenFileIsOpen: true });
  //       var reader = new FileReader();
  //       reader.readAsArrayBuffer(file);
  //       reader.onload = () => {
  //         const buffer = reader.result;

  //         const data = new Buffer(new Uint8Array(buffer)).toString();

  //         this.setState({
  //           dataDecrypt: { ...this.state.dataDecrypt, token: data },
  //         });
  //         console.log(data);
  //       };
  //       reader.onerror = (e) => {
  //         console.error(e);
  //       };
  //     } else {
  //       this.setState({ tokenFileName: "файл", tokenFileIsOpen: false });
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  handleDecryptSubmit(e) {
    e.preventDefault();
    try {
      Decrypt(
        btoa(unescape(encodeURIComponent(this.state.dataDecrypt.alg))),
        this.state.dataDecrypt.data,

        this.state.dataDecrypt.dataPrivKey,
      ).then((res) => {
        console.log(res);
        if (res.status === 200) {
          FileDownload(
            new Buffer.from(res.data.decrypt, "base64").toString(),
            "decrypt.txt"
          );
          document.getElementById("view").style.borderColor = "green";
        } else {
          document.getElementById("view").style.borderColor = "red";
        }
      });
    } catch (error) {
      document.getElementById("view").style.borderColor = "red";

      console.log(error);
    }
  }

  render() {
    return (
      <div className="container">
        <Form onSubmit={this.handleDecryptSubmit}>
          <div className="sm-4">
            <Form.Group
              style={{ paddingBottom: "20px", borderBottom: "1px solid white" }}
            >
              <Form.Label>Выберите файл </Form.Label>

              <Form.File custom>
                <Form.File.Input
                  id="dataForDecrypt"
                  onChange={this.handleFileForDecryptChange}
                  isValid={this.state.dataFileIsOpen}
                  isInvalid={!this.state.isValidFileSize}

                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.dataFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
              </Form.File>
            </Form.Group>
            <Form.Group>
              <Form.Label>Алгоритм шифрования</Form.Label>
              <Form.Control
                onChange={this.handleSelectChange}
                defaultValue={this.state.dataDecrypt.alg}
                as="select"
                custom
              >
                <option>belt-ctr256</option>
                <option>belt-ecb256</option>
                <option>belt-cbc256</option>
                <option>belt-cfb256</option>
              </Form.Control>
            </Form.Group>
            {/* <Form.Group>
              <Form.Label>Выберите токен</Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="fileToken"
                  onChange={this.handleTokenChange}
                  isValid={this.state.tokenFileIsOpen}
                  required
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.tokenFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
              </Form.File>
            </Form.Group> */}
            <Form.Group>
              <Form.Label>Выберите файл 32байтового ключа</Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="filePrivKey"
                  onChange={this.handlePrivKeyChange}
                  isValid={this.state.privkeyFileIsOpen}
                  isInvalid={!this.state.isValid32KeyFileSize}

                  required
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.privkeyFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
              </Form.File>
            </Form.Group>
            {/* <Form.Group>
              <Form.Label>Введите пароль личного ключа</Form.Label>
              <Form.Control
                type="password"
                placeholder="Пароль"
                onChange={this.handleInputChangePass}
                style={{ height: "2rem" }}
                required
              />
            </Form.Group> */}

            {/* <Form.Label style={{ float: "left" }}>
              {this.state.dataSign.statusSign}
            </Form.Label> */}
            <Button
              style={{ float: "right" }}
              type="submit"
              size="sm"
            >
              Расшифровать
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
export default connect()(withRouter(DecryptView));
